import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseURL: 'https://event.21jingji.com/xin_yin/',//接口目录
    jsonBasePath: './ApiJson/', // 假设的 JSON 基路径
    isPopOpen: false,
    isShowRulePop: false,
    isShowQrPop: false,
    isLogin: true
    // ruleDescLink:"https://www.citic-wealth.com/wechat/product/#/studyMoneyManage",//活动规则 "查看详"
  },
  getters: {
    isPopOpen: function (state) {
      return state.isPopOpen;
    },
    isShowRulePop: function (state) {
      return state.isShowRulePop;
    },
    isShowQrPop: function (state) {
      return state.isShowQrPop;
    },
    isLogin: function (state) {
      return state.isLogin;
    }
    // ruleDescLink:function(state){
    //   return state.ruleDescLink;
    // }
  },
  mutations: {
    login(state) {
      state.isLogin = true;
    },
    showRulePop(state) {
      state.isPopOpen = true;
      state.isShowRulePop = true;
    },
    hideRulePop(state) {
      state.isPopOpen = false;
      state.isShowRulePop = false;
      //回滚顶部
      document.body.scrollTo = 0;
      document.documentElement.scrollTo = 0;
      window.scrollTo(0, 0);
    },
    showQrPop(state) {
      state.isPopOpen = true;
      state.isShowQrPop = true;
    },
    hideQrPop(state) {
      state.isPopOpen = false;
      state.isShowQrPop = false;
      //回滚顶部
      document.body.scrollTo = 0;
      document.documentElement.scrollTo = 0;
      window.scrollTo(0, 0);
    },

  },
  actions: {

  },
  modules: {

  }
})
